(function () {
    'use strict';

    angular
        .module('cacmFollowUpModule')
        .controller('cacmFollowUpFullController', Controller);

    Controller.$inject = ['$scope', '$rootScope', 'attachmentService', 'cacmService'];

    function Controller($scope, $rootScope, attachmentService, cacmService) {
        $scope.statuses = {};
        var cleanBoxModel;
        initBoxModel();

        cacmService.getAllLookups().then(function (lookUps) {
            //noinspection JSUnresolvedVariable
            lookUps.CACMEventStatuses.forEach(function (status) {
                $scope.statuses[status.Value] = status;
            });
        });

        var removeListener = $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
            if ($scope.ctxtBox.isDirty && toState.url !== fromState.url) {
                event.preventDefault();
                $scope.confirmClick();
            }
        });
        $scope.$on("$destroy", removeListener);


        // SHOW/HIDE ELEMENTS

        $scope.showActions = function () {
            return $scope.isPageDirty() || $scope.boxModel.FollowUpID;
        };

        $scope.showPostFollowUp = function () {
            return $scope.statuses['UnderInvestigation']
                && $scope.boxContext.Event.EventStatus.Value === $scope.statuses['UnderInvestigation'].Value;
        };

        $scope.showInvestigateAction = function () {
            return $scope.statuses['New']
                && $scope.boxContext.Event.EventStatus.Value === $scope.statuses['New'].Value
                || $scope.statuses['Closed']
                && $scope.boxContext.Event.EventStatus.Value === $scope.statuses['Closed'].Value;
        };

        $scope.showCloseAction = function () {
            return $scope.statuses['New']
                && $scope.boxContext.Event.EventStatus.Value === $scope.statuses['New'].Value
                || $scope.statuses['UnderInvestigation']
                && $scope.boxContext.Event.EventStatus.Value === $scope.statuses['UnderInvestigation'].Value;
        };

        $scope.checkIfPageDirty = function () {
            var dirty = false;
            if (!_.isEqual($scope.boxModel, cleanBoxModel)) {
                dirty = true;
            }
            $scope.setPageDirty(dirty);
        };


        // ACTIONS
        $scope.okToCloseModal = true;

        $scope.draftFollowUp = function () {
            initAjaxSpinner();
            cacmService
                .saveFollowUpDraft($scope.boxContext.Event.CACMEventID, $scope.boxModel)
                .then(function (result) {
                    // Need refresh
                    $rootScope.$broadcast('need-refresh', result);
                    initBoxModel();
                }, function() {
                    initBoxModel();
                });
        };

        $scope.followUpAction = function(action) {
            initAjaxSpinner();
            cacmService
                .followUpPostAction(action, $scope.boxContext.Event.CACMEventID, $scope.boxModel)
                .then(function (result) {
                    // Need refresh
                    $rootScope.$broadcast('need-refresh', result);
                    initBoxModel(true);
                }, function() {
                    initBoxModel();
                });
        };

        $scope.postFollowUp = function () {
            $scope.followUpAction('Post');
        };

        $scope.investigateFollowUp = function () {
            $scope.followUpAction('Investigate');
        };

        $scope.closeFollowUp = function () {
            $scope.followUpAction('Close');
        };

        $scope.deleteDraft = function () {
            if ($scope.boxModel.FollowUpID) {
                initAjaxSpinner();
                cacmService
                    .deleteFollowUp($scope.boxContext.Event.CACMEventID, $scope.boxModel)
                    .then(function () {
                        initBoxModel(true);
                    });
            } else {
                initBoxModel(true);
            }
        };

        /**
         * Initiate the different box model properties and scope flags.
         * @param {boolean} [resetModel] true to clear all of the box model content
         */
        function initBoxModel(resetModel) {
            if (!$scope.boxModel) {
                $scope.boxModel = {};
            } else if (resetModel) {
                // Reset draft, clear all content
                for (var p in $scope.boxModel) {
                    if ($scope.boxModel.hasOwnProperty(p)) {
                        delete $scope.boxModel[p];
                    }
                }
            }
            cleanBoxModel = _.cloneDeep($scope.boxModel);
            $scope.setPageDirty(false);
            $scope.loading = false;
        }

        function initAjaxSpinner() {
            $scope.loading        = true;
            $scope.okToCloseModal = false;
            // $timeout(function () {
                $scope.okToCloseModal = true;
            // }, 500);
        }

        // Upload attachments
        $scope.uploadAttachments = function (files, events) {
            if (_.isUndefined($scope.boxModel.Attachments)) {
                $scope.boxModel.Attachments = [];
            }

            attachmentService.uploadSelectedFiles(files, events, $scope.boxModel.Attachments)
                .then(function () {
                    $scope.setPageDirty(true);
                });
        };

        // Delete attachment
        $scope.deleteAttachment = function (attachment) {
            attachmentService
                .delete(attachment.AttachmentExternalID)
                .then(function () {
                    var attachments = $scope.boxModel.Attachments;
                    _.remove(attachments, function (att) {
                        return att.AttachmentExternalID === attachment.AttachmentExternalID;
                    });
                });
        };
    }
})();